import {useCallback, useEffect, useState} from "react";

import styled from "styled-components";
import PopupMain from "../components/popup_main";
import MarkdownField from "../components/markdown_field";
import {useEditComment, useRawContent} from "../api/edit";
import useFeedback from "../utils/use_feedback";
import {useSaveClicked, useStoreComment} from "../store";
import {useActions} from "../app_context";
import renderMarkdown from "../utils/render_markdown";
import TopBar from "../components/top_bar";

const EditComment = styled(({className, commentId, onClose}) => {
    const actions = useActions();
    const {feedbackCh, error} = useFeedback(true);
    const editComment = useEditComment(feedbackCh);
    const comment = useStoreComment(commentId);
    // TODO: consider setting the initial content to 'loading...'
    const [content, setContent] = useState('');
    const [originalContent, setOriginalContent] = useState('');
    const loadContent = useCallback((content) => {
        setContent(content);
        setOriginalContent(content);
    }, [setContent, setOriginalContent]);
    useRawContent(feedbackCh, commentId, 'comment', loadContent);
    const [reason, setReason] = useState('');
    const edit = async () => {
        try {
            actions.commentEdited(commentId, renderMarkdown(content));
            await editComment(commentId, content, reason);
            onClose();
        } catch {
            actions.commentEdited(commentId, renderMarkdown(originalContent));
            // error is displayed
        }
    };
    const saveClicked = useSaveClicked();
    const [saving, setSaving] = useState(false);
    useEffect(() => {
        (async () => {
            if (saveClicked) {
                if (!saving) {
                    setSaving(true);
                    await edit();
                    setSaving(false);
                }
            }
        })().then(() => {}, () => {});
    }, [saveClicked]);

    return (
        <>
            <TopBar back save border={false} title={'Edit Comment'} transparentBackground={false}/>
            <PopupMain className={className}>
                <MarkdownField
                    id='content' placeholder="Type your comment..." minRows={5}
                    value={content} onChange={setContent} autoFocus
                />
            </PopupMain>
        </>
    );
})`
  ${MarkdownField} textarea {
    border: none;
    min-height: 100%;
    outline: none;
  }
  ${MarkdownField} {
    height: 100%;
    margin-bottom: 0;
  }
`;

export default EditComment;
